/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPhoneSmartOffIcon24Solid = forwardRef('TechPhoneSmartOffIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.384 1.616A1.25 1.25 0 1 0 .616 3.384l20 20a1.25 1.25 0 0 0 1.768-1.768l-2.532-2.532c.096-.345.148-.708.148-1.084V6a4 4 0 0 0-4-4H8c-1.42 0-2.667.74-3.377 1.855l-2.24-2.239ZM8.73 7.963l-.694-.694a1 1 0 1 1 .694.694Z" }),
        React.createElement("path", { d: "M4 18V9.828L11.172 17H9a1 1 0 1 0 0 2h4.172l2.996 2.997A4.076 4.076 0 0 1 16 22H8a4 4 0 0 1-4-4Z" })));
});
